import React from 'react'
import './TermsPage.css'

function TermsPage() {
  return (
    <div className="terms-page">
      <div className="terms-hero">
        <div className="container">
          <h1>Terms & Conditions</h1>
          <p>Please read these terms carefully before using MoRecharz services</p>
        </div>
      </div>

      <div className="container">
        <div className="terms-content">

          <section className="terms-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing, browsing, or using the MoRecharz platform (website and/or mobile application), you agree to be bound by these Terms and Conditions and all applicable laws in India. If you do not agree to these terms, please discontinue using our services immediately.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Scope of Services</h2>
            <p>
              MoRecharz operates as a reseller platform providing digital prepaid mobile recharges, DTH top-ups, and utility bill payment services. MoRecharz is an intermediary and does not directly provide telecom, DTH, or utility services. All services purchased through our platform are subject to the terms, plans, and conditions of the respective service providers (e.g., Jio, Airtel, Vi, BSNL).
            </p>
          </section>

          <section className="terms-section">
            <h2>3. User Responsibility & Accuracy of Data</h2>
            <p>
              When initiating a recharge or bill payment, you are solely responsible for ensuring the accuracy of the details entered, including but not limited to:
            </p>
            <ul>
              <li>The mobile number, DTH account number, or consumer ID.</li>
              <li>The selected telecom operator and circle.</li>
              <li>The specific recharge plan amount selected.</li>
            </ul>
            <blockquote>
              <strong>Important Note:</strong> MoRecharz will not be liable for any successful recharges processed against an incorrect mobile number or account detail provided by the user. Such transactions cannot be reversed or refunded under any circumstances.
            </blockquote>
          </section>

          <section className="terms-section">
            <h2>4. Payment, Convenience Fees, and Taxes</h2>
            <p>
              All payments must be completed in full through our integrated payment gateways. MoRecharz reserves the right to charge a nominal transaction or convenience fee per transaction over and above the recharge value. Any such fees will be clearly displayed before the final payment is initiated. All charges are inclusive of applicable GST unless stated otherwise.
            </p>
          </section>

          <section className="terms-section">
            <h2>5. Refund and Cancellation Policy</h2>
            <ul>
              <li><strong>Successful Transactions:</strong> All successful recharges are final. No cancellations or refunds are permitted once the operator confirms the transaction.</li>
              <li><strong>Failed Transactions:</strong> If money is deducted from your bank account/wallet but the recharge fails on our end, the amount will be automatically refunded to your original payment source within 5 to 7 working days, subject to your bank's processing policies.</li>
              <li><strong>Pending/Processing Transactions:</strong> In rare cases where a transaction status is pending due to operator API delays, MoRecharz will wait for a definitive status update from the operator before initiating a refund or confirming the recharge.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>6. Limitation of Liability</h2>
            <p>
              MoRecharz shall not be held liable for any direct, indirect, incidental, or consequential damages resulting from:
            </p>
            <ul>
              <li>Delays or failures on the part of telecom operators or utility companies in processing or activating a recharge.</li>
              <li>Unannounced changes in plans, validity, or talktime benefits made by telecom operators.</li>
              <li>Network downtime, server failures, or payment gateway errors outside of MoRecharz's immediate control.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>7. User Accounts & Security</h2>
            <p>
              If you register an account with MoRecharz, you are responsible for maintaining the confidentiality of your login credentials (OTP, passwords, etc.). You agree to accept responsibility for all activities that occur under your account. You must notify us immediately of any unauthorized use or security breach.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Anti-Fraud and Fair Use Policy</h2>
            <p>
              MoRecharz monitors transactions for fraudulent activity. We reserve the right to suspend, terminate, or block any user account or decline transactions if we suspect any fraudulent behavior, money laundering, usage of unauthorized scripts, or abuse of promotional offers/cashbacks.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Governing Law and Jurisdiction</h2>
            <p>
              These Terms and Conditions shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these terms shall be subject to the exclusive jurisdiction of the competent courts in Bangalore, Karnataka.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Contact Us</h2>
            <p>
              For support, transactional issues, or complaints regarding failed recharges, please contact our support team:
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:support@morecharz.com">support@morecharz.com</a><br />
              <strong>Hours:</strong> 24/7 Available
            </p>
          </section>

          <section className="terms-section last-updated">
            <p><em>Last Updated: July 2026</em></p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default TermsPage